import { httpClient } from '@/shared/api/httpClient';

export type TipoBatida = 'Entrada' | 'Saida';

export type ColaboradorPontoStatus = {
  colaboradorId: string;
  nome: string;
  cargo: string | null;
  trabalhando: boolean;
  desde: string | null;
  minutosHoje: number;
};

export type BatidaResumo = {
  id: string;
  colaboradorId: string;
  colaboradorNome: string;
  tipo: TipoBatida;
  momento: string;
  origem: string;
  observacao: string | null;
  syncPendente: boolean;
};

export type CriarBatidaRequest = {
  colaboradorId: string;
  tipo: TipoBatida;
  momento: string;
  observacao?: string | null;
};

export type AtualizarBatidaRequest = {
  tipo: TipoBatida;
  momento: string;
  observacao?: string | null;
};

export type FiltroBatidas = {
  colaboradorId?: string;
  inicio?: string;
  fim?: string;
};

function querystring(filtro: FiltroBatidas): string {
  const params = new URLSearchParams();
  if (filtro.colaboradorId) params.set('colaboradorId', filtro.colaboradorId);
  if (filtro.inicio) params.set('inicio', filtro.inicio);
  if (filtro.fim) params.set('fim', filtro.fim);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export const pontoApi = {
  status: () => httpClient.get<ColaboradorPontoStatus[]>('/api/ponto/status'),
  bater: (colaboradorId: string) =>
    httpClient.post<{ id: string; tipo: TipoBatida }>(`/api/ponto/${colaboradorId}/bater`, {}),
  listarBatidas: (filtro: FiltroBatidas = {}) =>
    httpClient.get<BatidaResumo[]>(`/api/ponto/batidas${querystring(filtro)}`),
  criar: (cmd: CriarBatidaRequest) => httpClient.post<{ id: string }>('/api/ponto/batidas', cmd),
  atualizar: (id: string, cmd: AtualizarBatidaRequest) =>
    httpClient.put<void>(`/api/ponto/batidas/${id}`, cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/ponto/batidas/${id}`),
};
